import { update as update_8, init as init_1 } from "./Notifications/State.js";
import { update as update_1, init as init_2 } from "./Auth/AuthState.js";
import { update as update_2, init as init_3 } from "./Users/UsersState.js";
import { update as update_4, init as init_4 } from "./Invitations/InvitationsState.js";
import { update as update_3, init as init_5 } from "./Practices/PracticesState.js";
import { init as init_6 } from "./Demonstration/DemonstrationPage.js";
import { init as init_7 } from "./Landing/LandingPage.js";
import { update as update_5, init as init_8 } from "./UserProfile/UserProfileState.js";
import { update as update_6, init as init_9 } from "./Package/PackageState.js";
import { singleton, ofArray, empty } from "./fable_modules/fable-library-js.4.25.0/List.js";
import { update as update_7, init as init_10 } from "./Media/MediaState.js";
import { update as update_9, init as init_11 } from "./PatientPackages/PatientPackagesState.js";
import { toArray, map as map_1, defaultArg, value as value_1, some, bind } from "./fable_modules/fable-library-js.4.25.0/Option.js";
import { handleUpdatedUrl } from "./Routing.js";
import { pageHash, Page, AuthPage } from "./Pages.js";
import { Msg, Model } from "./Types.js";
import { Cmd_OfPromise_either, Cmd_ofEffect, Cmd_none, Cmd_map, Cmd_batch } from "./fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { ProxyRequestException__get_StatusCode, ProxyRequestException } from "./fable_modules/Fable.Remoting.Client.7.35.0/Types.fs.js";
import { Msg as Msg_1 } from "./Auth/AuthTypes.js";
import { error } from "./ThreeDocs.SharedUI/Toast.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.25.0/String.js";
import { Msg as Msg_2 } from "./Users/UsersTypes.js";
import { Msg as Msg_8, MediaUpdateArgs } from "./Media/MediaTypes.js";
import { Navigation_newUrl } from "./fable_modules/Fable.Elmish.Browser.4.1.0/navigation.fs.js";
import { subscribe } from "./Users/UsersApi.js";
import { subscribe as subscribe_1 } from "./Practices/PracticesApi.js";
import { subscribe as subscribe_2 } from "./UserProfile/UserProfileApi.js";
import { subscribe as subscribe_3 } from "./Invitations/InvitationsApi.js";
import { subscribe as subscribe_4 } from "./Package/PackagesApi.js";
import { subscribe as subscribe_5 } from "./Media/MediaApi.js";
import { disconnect, subscribe as subscribe_6 } from "./Notifications/Api.js";
import { Cmd_OfAsyncWith_either } from "./fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "./fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedAwsApi } from "./Api.js";
import { S3Context, mkS3Client, updateGlobalConfig, mkCredentials } from "./Common/AwsCommon.js";
import { ofList } from "./fable_modules/fable-library-js.4.25.0/Map.js";
import { equals, comparePrimitives } from "./fable_modules/fable-library-js.4.25.0/Util.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { SessionManagement_SessionManagementModel__get_token } from "./Session.js";
import { iterate, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.25.0/Seq.js";
import { Msg as Msg_3 } from "./Notifications/Types.js";
import { Msg as Msg_4 } from "./Practices/PracticesTypes.js";
import { Msg as Msg_5 } from "./Invitations/InvitationsTypes.js";
import { Msg as Msg_6 } from "./UserProfile/UserProfileTypes.js";
import { Msg as Msg_7 } from "./Package/PackageTypes.js";

export function init(result) {
    const patternInput = init_1();
    const patternInput_1 = init_2();
    const patternInput_2 = init_3();
    const patternInput_3 = init_4();
    const patternInput_4 = init_5();
    const patternInput_5 = init_6();
    const patternInput_6 = init_7();
    const patternInput_7 = init_8();
    const patternInput_8 = init_9(undefined, empty());
    const patternInput_9 = init_10(undefined, empty());
    const patternInput_10 = init_11(bind((_arg) => {
        if (_arg.tag === 7) {
            return _arg.fields[0];
        }
        else {
            return undefined;
        }
    }, result));
    const patternInput_11 = handleUpdatedUrl(result, new Model(patternInput[0], new Page(0, [new AuthPage(0, [])]), undefined, patternInput_1[0], patternInput_2[0], patternInput_3[0], patternInput_4[0], patternInput_5[0], patternInput_6[0], patternInput_7[0], patternInput_8[0], patternInput_10[0], patternInput_9[0], false, undefined, undefined, undefined, undefined));
    return [patternInput_11[0], Cmd_batch(ofArray([patternInput_11[1], Cmd_map((Item) => (new Msg(8, [Item])), patternInput[1]), Cmd_map((Item_1) => (new Msg(2, [Item_1])), patternInput_1[1]), Cmd_map((Item_2) => (new Msg(4, [Item_2])), patternInput_2[1]), Cmd_map((Item_3) => (new Msg(3, [Item_3])), patternInput_4[1]), Cmd_map((Item_4) => (new Msg(6, [Item_4])), patternInput_5[1]), Cmd_map((Item_5) => (new Msg(7, [Item_5])), patternInput_6[1]), Cmd_map((Item_6) => (new Msg(9, [Item_6])), patternInput_7[1]), Cmd_map((Item_7) => (new Msg(5, [Item_7])), patternInput_3[1]), Cmd_map((Item_8) => (new Msg(10, [Item_8])), patternInput_8[1]), Cmd_map((Item_9) => (new Msg(12, [Item_9])), patternInput_9[1]), Cmd_map((Item_10) => (new Msg(11, [Item_10])), patternInput_10[1])]))];
}

export function authenticatedUpdate(token, msg, model) {
    let ex_1, rawTopics;
    let matchResult, ex, msg_12, msg_13, msg_14, practices_1, msg_17, msg_18, msg_19, msg_20, msg_21, page, client, msg_22, msg_24, active, config, r, credentials_3, s3Context_2;
    switch (msg.tag) {
        case 3: {
            switch (msg.fields[0].tag) {
                case 0: {
                    matchResult = 0;
                    ex = msg.fields[0].fields[0];
                    break;
                }
                case 3: {
                    if (msg.fields[0].fields[0].tag === 0) {
                        if (model.authModel.userInfo != null) {
                            matchResult = 3;
                            msg_14 = msg.fields[0];
                            practices_1 = msg.fields[0].fields[0].fields[0];
                        }
                        else if (model.authModel.userInfo != null) {
                            matchResult = 4;
                            msg_17 = msg.fields[0];
                        }
                        else {
                            matchResult = 9;
                        }
                    }
                    else if (model.authModel.userInfo != null) {
                        matchResult = 4;
                        msg_17 = msg.fields[0];
                    }
                    else {
                        matchResult = 9;
                    }
                    break;
                }
                default:
                    if (model.authModel.userInfo != null) {
                        matchResult = 4;
                        msg_17 = msg.fields[0];
                    }
                    else {
                        matchResult = 9;
                    }
            }
            break;
        }
        case 4: {
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else if (model.authModel.userInfo != null) {
                matchResult = 2;
                msg_13 = msg.fields[0];
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 5: {
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else if (model.authModel.userInfo != null) {
                matchResult = 5;
                msg_18 = msg.fields[0];
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 6: {
            matchResult = 0;
            ex = msg.fields[0].fields[0];
            break;
        }
        case 9: {
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else if (model.authModel.userInfo != null) {
                matchResult = 6;
                msg_19 = msg.fields[0];
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 7: {
            matchResult = 0;
            ex = msg.fields[0].fields[0];
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else if (model.authModel.userInfo != null) {
                matchResult = 7;
                msg_20 = msg.fields[0];
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 12: {
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else if (model.authModel.userInfo != null) {
                matchResult = 8;
                msg_21 = msg.fields[0];
            }
            else {
                matchResult = 9;
            }
            break;
        }
        case 0: {
            matchResult = 0;
            ex = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 9;
            break;
        }
        case 1: {
            matchResult = 10;
            page = msg.fields[0];
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 3) {
                matchResult = 11;
                client = msg.fields[0].fields[0];
                msg_22 = msg.fields[0];
            }
            else {
                matchResult = 12;
                msg_24 = msg.fields[0];
            }
            break;
        }
        case 13: {
            matchResult = 13;
            active = msg.fields[0];
            break;
        }
        case 14: {
            matchResult = 14;
            break;
        }
        case 15: {
            matchResult = 15;
            config = msg.fields[0];
            break;
        }
        case 16: {
            matchResult = 16;
            r = msg.fields[0];
            break;
        }
        case 17: {
            matchResult = 17;
            credentials_3 = msg.fields[0];
            s3Context_2 = msg.fields[1];
            break;
        }
        default:
            if (msg.fields[0].tag === 0) {
                matchResult = 0;
                ex = msg.fields[0].fields[0];
            }
            else {
                matchResult = 1;
                msg_12 = msg.fields[0];
            }
    }
    switch (matchResult) {
        case 0:
            return [model, (ex instanceof ProxyRequestException) ? ((ex_1 = ex, (ProxyRequestException__get_StatusCode(ex_1) === 401) ? Cmd_batch(ofArray([singleton((dispatch) => {
                dispatch(new Msg(2, [new Msg_1(6, [])]));
            }), error("You have been logged out")])) : Cmd_none())) : ((console.error(some(toText(printf("Error: %O"))(ex))), Cmd_none()))];
        case 1: {
            const patternInput = update_1(msg_12, model.authModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, patternInput[0], model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])];
        }
        case 2: {
            const patternInput_1 = update_2(token, value_1(model.authModel.userInfo), msg_13, model.usersModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, patternInput_1[0], model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_1) => (new Msg(4, [Item_1])), patternInput_1[1])];
        }
        case 3: {
            const patternInput_2 = update_3(token, value_1(model.authModel.userInfo), msg_14, model.practicesModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, patternInput_2[0], model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_batch(ofArray([Cmd_map((Item_2) => (new Msg(3, [Item_2])), patternInput_2[1]), singleton((dispatch_1) => {
                dispatch_1(new Msg(4, [new Msg_2(4, [practices_1])]));
            })]))];
        }
        case 4: {
            const patternInput_3 = update_3(token, value_1(model.authModel.userInfo), msg_17, model.practicesModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, patternInput_3[0], model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_4) => (new Msg(3, [Item_4])), patternInput_3[1])];
        }
        case 5: {
            const patternInput_4 = update_4(token, value_1(model.authModel.userInfo), msg_18, model.invitationsModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, patternInput_4[0], model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_5) => (new Msg(5, [Item_5])), patternInput_4[1])];
        }
        case 6: {
            const patternInput_5 = update_5(token, value_1(model.authModel.userInfo), msg_19, model.userProfileModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, patternInput_5[0], model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_6) => (new Msg(9, [Item_6])), patternInput_5[1])];
        }
        case 7: {
            const matchValue_1 = model.currentPage;
            if (matchValue_1.tag === 6) {
                const patternInput_6 = update_6(token, value_1(model.authModel.userInfo), matchValue_1.fields[0], msg_20, model.packagesModel);
                return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, patternInput_6[0], model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_7) => (new Msg(10, [Item_7])), patternInput_6[1])];
            }
            else {
                return [model, Cmd_none()];
            }
        }
        case 8: {
            const args = new MediaUpdateArgs(token, model.credentials, model.s3Context);
            const matchValue_2 = model.currentPage;
            if (matchValue_2.tag === 8) {
                const patternInput_7 = update_7(args, value_1(model.authModel.userInfo), matchValue_2.fields[0], msg_21, model.mediaModel);
                return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, patternInput_7[0], model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_8) => (new Msg(12, [Item_8])), patternInput_7[1])];
            }
            else {
                const patternInput_8 = update_7(args, value_1(model.authModel.userInfo), undefined, msg_21, model.mediaModel);
                return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, patternInput_8[0], model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_9) => (new Msg(12, [Item_9])), patternInput_8[1])];
            }
        }
        case 9:
            return [model, error("Unable to find active user.")];
        case 10:
            return [model, Cmd_batch(singleton(Navigation_newUrl(pageHash(page))))];
        case 11: {
            const patternInput_9 = update_8(token, msg_22, model.notificationsModel);
            const toSubs = (tupledArg, map) => [tupledArg[0], (arg_1) => map(tupledArg[1](arg_1))];
            const subs_1 = Cmd_ofEffect((rawTopics = defaultArg(map_1((ui) => ofArray([toSubs(subscribe(ui.id), (Item_10) => (new Msg(4, [Item_10]))), toSubs(subscribe_1(ui.id), (Item_11) => (new Msg(3, [Item_11]))), toSubs(subscribe_2(ui.id), (Item_12) => (new Msg(9, [Item_12]))), toSubs(subscribe_3(ui.id), (Item_13) => (new Msg(5, [Item_13]))), toSubs(subscribe_4(ui.id), (Item_14) => (new Msg(10, [Item_14]))), toSubs(subscribe_5(ui.id), (Item_15) => (new Msg(12, [Item_15])))]), model.authModel.userInfo), empty()), (dispatch_2) => {
                subscribe_6(client, rawTopics, dispatch_2);
            }));
            return [new Model(patternInput_9[0], model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_batch(ofArray([Cmd_map((Item_16) => (new Msg(8, [Item_16])), patternInput_9[1]), subs_1]))];
        }
        case 12: {
            const patternInput_10 = update_8(token, msg_24, model.notificationsModel);
            return [new Model(patternInput_10[0], model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_17) => (new Msg(8, [Item_17])), patternInput_10[1])];
        }
        case 13:
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, active, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_none()];
        case 14:
            return [model, Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, securedAwsApi(token).getS3Configuration, undefined, (Item_18) => (new Msg(15, [Item_18])), (Item_19) => (new Msg(0, [Item_19])))];
        case 15:
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, config, model.credentials), Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedAwsApi(token).getIdentity, undefined, (Item_20) => (new Msg(16, [Item_20])), (Item_21) => (new Msg(0, [Item_21])))];
        case 16: {
            const matchValue_3 = model.s3Configuration;
            if (matchValue_3 != null) {
                const config_1 = matchValue_3;
                if (r.tag === 1) {
                    return [model, Cmd_none()];
                }
                else {
                    const result = r.fields[0];
                    const credentials = mkCredentials(config_1.IdentityPoolId, result.IdentityId, config_1.Region, ofList(singleton([config_1.Authority, result.Token]), {
                        Compare: comparePrimitives,
                    }));
                    updateGlobalConfig(config_1.Region, credentials);
                    const s3Context = new S3Context(config_1, mkS3Client(config_1.Bucket), undefined, config_1.Bucket);
                    return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, s3Context, result, model.s3Configuration, credentials), Cmd_OfPromise_either((tupledArg_1) => {
                        const credentials_1 = tupledArg_1[0];
                        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (credentials_1.getPromise().then(() => (Promise.resolve([credentials_1, tupledArg_1[1]]))))));
                    }, [credentials, s3Context], (tupledArg_2) => (new Msg(17, [tupledArg_2[0], tupledArg_2[1]])), (Item_24) => (new Msg(0, [Item_24])))];
                }
            }
            else {
                return [model, Cmd_none()];
            }
        }
        default:
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, new S3Context(s3Context_2.S3Config, s3Context_2.S3Client, credentials_3.expireTime, s3Context_2.ActiveBucket), model.awsToken, model.s3Configuration, model.credentials), Cmd_none()];
    }
}

export function update(msg, model) {
    let tupledArg;
    const matchValue = SessionManagement_SessionManagementModel__get_token(model.authModel.sessionManagement);
    let matchResult, msg_1, token, msg_2, msg_11, msg_12, msg_13, msg_14, token_1, msg_15;
    if (matchValue != null) {
        switch (msg.tag) {
            case 2: {
                switch (msg.fields[0].tag) {
                    case 0: {
                        matchResult = 0;
                        msg_1 = msg;
                        token = matchValue;
                        break;
                    }
                    case 18: {
                        matchResult = 1;
                        msg_2 = msg.fields[0];
                        break;
                    }
                    case 6: {
                        matchResult = 2;
                        msg_11 = msg.fields[0];
                        break;
                    }
                    default: {
                        matchResult = 3;
                        msg_12 = msg.fields[0];
                    }
                }
                break;
            }
            case 11: {
                matchResult = 4;
                msg_13 = msg.fields[0];
                break;
            }
            default: {
                matchResult = 5;
                msg_14 = msg;
                token_1 = matchValue;
            }
        }
    }
    else {
        switch (msg.tag) {
            case 2: {
                switch (msg.fields[0].tag) {
                    case 18: {
                        matchResult = 1;
                        msg_2 = msg.fields[0];
                        break;
                    }
                    case 6: {
                        matchResult = 2;
                        msg_11 = msg.fields[0];
                        break;
                    }
                    default: {
                        matchResult = 3;
                        msg_12 = msg.fields[0];
                    }
                }
                break;
            }
            case 11: {
                matchResult = 4;
                msg_13 = msg.fields[0];
                break;
            }
            default: {
                matchResult = 6;
                msg_15 = [matchValue, msg];
            }
        }
    }
    switch (matchResult) {
        case 0:
            return authenticatedUpdate(token.rawToken, msg_1, model);
        case 1: {
            const patternInput = update_1(msg_2, model.authModel);
            return [new Model(model.notificationsModel, model.currentPage, equals(model.currentPage, new Page(0, [new AuthPage(0, [])])) ? undefined : model.redirectPage, patternInput[0], model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_batch(toList(delay(() => append(singleton_1(Cmd_map((Item) => (new Msg(2, [Item])), patternInput[1])), delay(() => append(singleton_1(singleton((dispatch) => {
                dispatch(new Msg(8, [new Msg_3(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_1) => {
                dispatch_1(new Msg(4, [new Msg_2(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_2) => {
                dispatch_2(new Msg(3, [new Msg_4(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_3) => {
                dispatch_3(new Msg(5, [new Msg_5(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_4) => {
                dispatch_4(new Msg(9, [new Msg_6(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_5) => {
                dispatch_5(new Msg(10, [new Msg_7(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_6) => {
                dispatch_6(new Msg(12, [new Msg_8(1, [])]));
            })), delay(() => append(singleton_1(singleton((dispatch_7) => {
                dispatch_7(new Msg(14, []));
            })), delay(() => {
                const matchValue_2 = model.currentPage;
                let matchResult_1;
                if (matchValue_2.tag === 0) {
                    if (matchValue_2.fields[0].tag === 0) {
                        matchResult_1 = 0;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const matchValue_3 = model.redirectPage;
                        return (matchValue_3 != null) ? singleton_1(Navigation_newUrl(pageHash(matchValue_3))) : singleton_1(Navigation_newUrl(pageHash(new Page(10, []))));
                    }
                    default:
                        return singleton_1(Cmd_none());
                }
            })))))))))))))))))))))];
        }
        case 2: {
            const patternInput_1 = update_1(msg_11, model.authModel);
            iterate((arg) => {
                disconnect(arg);
            }, toArray(model.notificationsModel.Client));
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, patternInput_1[0], model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_1) => (new Msg(2, [Item_1])), patternInput_1[1])];
        }
        case 3: {
            const patternInput_2 = update_1(msg_12, model.authModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, patternInput_2[0], model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, model.patientPackagesModel, model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_2) => (new Msg(2, [Item_2])), patternInput_2[1])];
        }
        case 4: {
            const patternInput_3 = update_9(msg_13, model.patientPackagesModel);
            return [new Model(model.notificationsModel, model.currentPage, model.redirectPage, model.authModel, model.usersModel, model.invitationsModel, model.practicesModel, model.demonstrationModel, model.landingModel, model.userProfileModel, model.packagesModel, patternInput_3[0], model.mediaModel, model.menuIsExpanded, model.s3Context, model.awsToken, model.s3Configuration, model.credentials), Cmd_map((Item_3) => (new Msg(11, [Item_3])), patternInput_3[1])];
        }
        case 5:
            return authenticatedUpdate(token_1.rawToken, msg_14, model);
        default: {
            console.log(some((tupledArg = msg_15, toText(printf("Ignoring unauthenticated msg: %O"))([tupledArg[0], tupledArg[1]]))));
            return [model, Cmd_none()];
        }
    }
}

